'use client'

import { useParams } from 'next/navigation'
import { useEffect } from 'react'

import type { MyTicketDetailModel } from '@/components/myTicket/model'
import AirportPurchase from '@/components/purchase/components/airport/view'
import ExtendParkinglotPurchase from '@/components/purchase/components/extendParkinglot/view'
import { TicketDetailModel } from '@/components/purchase/components/parkinglot/model'
import ParkinglotPurchase from '@/components/purchase/components/parkinglot/view'
import SharedParkinglotPurchase from '@/components/purchase/components/sharedParkinglot/view'

import type { AirportTicketDetail } from '@/api/server/airport/dto/airportDto'
import Shared from '@/shared'

import { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import NotFound from '@/app/not-found'

const PurchaseClientView = ({
  data
}: {
  data: TicketDetailModel | SharedParkinglotDetail | MyTicketDetailModel | AirportTicketDetail
}) => {
  const { id } = useParams()
  const resetStep = Shared.States.usePurchaseStep((s) => s.resetPurchaseStep)

  useEffect(() => {
    resetStep()
  }, [id])

  if (!data) return <NotFound />

  if ('labels' in data) {
    return <AirportPurchase data={data} />
  }

  if ('type' in data) {
    return <SharedParkinglotPurchase data={data} />
  }

  if ('ticket' in data) {
    return <ExtendParkinglotPurchase data={data} />
  }

  return <ParkinglotPurchase data={data} />
}

export default PurchaseClientView
